(() => {
  const init = (root) => {
    if (!root || root.dataset.donorReady === 'true') return;
    root.dataset.donorReady = 'true';

    const gallery = root.querySelector('[data-product-gallery]');
    if (gallery) {
      const mainImage = gallery.querySelector('[data-gallery-main]');
      const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
      const dialog = gallery.querySelector('[data-zoom-dialog]');
      const zoomImage = gallery.querySelector('[data-zoom-image]');
      let activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.getAttribute('aria-pressed') === 'true'));

      const showImage = (index) => {
        if (!thumbs.length || !mainImage) return;
        activeIndex = (index + thumbs.length) % thumbs.length;
        const thumb = thumbs[activeIndex];
        mainImage.src = thumb.dataset.full;
        mainImage.srcset = thumb.dataset.srcset || '';
        mainImage.alt = thumb.dataset.alt || '';
        mainImage.dataset.zoomSrc = thumb.dataset.zoom || thumb.dataset.full;
        thumbs.forEach((item, itemIndex) => {
          const selected = itemIndex === activeIndex;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        if (dialog?.open && zoomImage) zoomImage.src = mainImage.dataset.zoomSrc;
      };

      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showImage(index)));
      gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showImage(activeIndex - 1));
      gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => showImage(activeIndex + 1));
      gallery.querySelector('[data-zoom-trigger]')?.addEventListener('click', () => {
        if (!dialog?.showModal || !zoomImage) return;
        zoomImage.src = mainImage.dataset.zoomSrc || mainImage.src;
        dialog.showModal();
      });
      gallery.querySelector('[data-zoom-close]')?.addEventListener('click', () => dialog?.close());
      gallery.querySelector('[data-zoom-prev]')?.addEventListener('click', () => showImage(activeIndex - 1));
      gallery.querySelector('[data-zoom-next]')?.addEventListener('click', () => showImage(activeIndex + 1));
    }

    root.querySelectorAll('[data-product-tabs]').forEach((tabs) => {
      const buttons = [...tabs.querySelectorAll('[data-product-tab]')];
      const panels = [...tabs.querySelectorAll('[data-product-panel]')];
      if (!buttons.length || !panels.length) return;
      const activate = (button, moveFocus = false) => {
        buttons.forEach((item) => {
          const active = item === button;
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => {
          panel.hidden = panel.id !== button.getAttribute('aria-controls');
        });
        tabs.dataset.tabsEnhanced = 'true';
        if (moveFocus) button.focus();
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activate(button));
        button.addEventListener('keydown', (event) => {
          if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
          activate(buttons[next], true);
        });
      });
      activate(buttons.find((button) => button.getAttribute('aria-selected') === 'true') || buttons[0]);
    });
  };

  const start = () => document.querySelectorAll('[data-donor-vehicle]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-donor-vehicle]')));
})();
